/* Notivo Premium Startseite — Reveal-, Parallax- und Video-Steuerung */
(function () {
  'use strict';

  // Jede nv-Sektion bindet dieses Script ein — nur einmal initialisieren
  if (window.__nvHome) return;
  window.__nvHome = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mobileQuery = window.matchMedia('(max-width: 749px)');
  var touchQuery = window.matchMedia('(hover: none), (max-width: 989px)');

  function splitWords(el) {
    if (el.dataset.nvSplitDone) return;
    el.dataset.nvSplitDone = '1';
    var index = 0;
    var walk = function (node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (child) {
        if (child.nodeType === 3) {
          var frag = document.createDocumentFragment();
          child.textContent.split(/(\s+)/).forEach(function (part) {
            if (!part) return;
            if (/^\s+$/.test(part)) {
              frag.appendChild(document.createTextNode(' '));
              return;
            }
            var outer = document.createElement('span');
            outer.className = 'nv-split__w';
            var inner = document.createElement('span');
            inner.className = 'nv-split__i';
            inner.style.setProperty('--nv-w', index++);
            inner.textContent = part;
            outer.appendChild(inner);
            frag.appendChild(outer);
          });
          child.parentNode.replaceChild(frag, child);
        } else if (child.nodeType === 1 && child.tagName !== 'BR') {
          walk(child);
        }
      });
    };
    walk(el);
  }

  function pickVideoSource(video) {
    var src = mobileQuery.matches && video.dataset.srcMobile ? video.dataset.srcMobile : video.dataset.src;
    if (!src || video.dataset.current === src) return;
    video.dataset.current = src;
    video.src = src;
    video.load();
  }

  function initVideo(video) {
    if (video.dataset.nvVideoInit) return;
    video.dataset.nvVideoInit = '1';
    video.muted = true;
    video.playsInline = true;
    if (reduceMotion) return;
    video.addEventListener('loadeddata', function () { video.classList.add('is-ready'); });
    if (video.hasAttribute('data-nv-autoplay')) {
      pickVideoSource(video);
      video.play().catch(function () {});
    }
  }

  function playInView(video) {
    if (reduceMotion) return;
    if (!video.dataset.current) pickVideoSource(video);
    var once = video.hasAttribute('data-nv-once');
    if (once && video.dataset.played) return;
    video.play().then(function () { video.dataset.played = '1'; }).catch(function () {});
  }

  // Beispieltext tippen (Suchfeld, KI-Frage). Mit data-nv-type-multi: mehrere Sätze mit „|“ – jeder Durchlauf nimmt den nächsten, der letzte bleibt stehen
  function typeText(el) {
    if (el.dataset.nvTyped) return;
    el.dataset.nvTyped = '1';
    var raw = String(el.getAttribute('data-nv-type') || el.textContent);
    var phrases = el.hasAttribute('data-nv-type-multi')
      ? raw.split('|').map(function (s) { return s.trim(); }).filter(Boolean)
      : [raw].filter(Boolean);
    if (reduceMotion || !phrases.length) { el.textContent = phrases.length ? phrases[phrases.length - 1] : raw; return; }
    var rounds = phrases.length > 1 ? phrases.length : 3;
    var full = phrases[0];
    var i = 0, erasing = false, round = 0;
    el.textContent = '';
    el.classList.add('is-typing');
    function step() {
      if (!erasing) {
        i += 1; el.textContent = full.slice(0, i);
        if (i >= full.length) {
          round += 1;
          if (round >= rounds) { setTimeout(function () { el.classList.remove('is-typing'); }, 2500); return; }
          erasing = true; setTimeout(step, 2400); return;
        }
        setTimeout(step, 70 + Math.random() * 70);
      } else {
        i -= 1; el.textContent = full.slice(0, i);
        if (i <= 0) { erasing = false; full = phrases[round % phrases.length]; setTimeout(step, 600); return; }
        setTimeout(step, 32);
      }
    }
    setTimeout(step, 500);
  }

  // Akkordeons (FAQ, Lieferumfang …): Antwort gleitet weich auf und zu, statt zu springen
  function initAccordion(details) {
    if (details.dataset.nvAccInit) return;
    details.dataset.nvAccInit = '1';
    var summary = details.querySelector(':scope > summary');
    var body = details.querySelector(':scope > .nv-acc__body');
    if (!summary || !body || reduceMotion || typeof body.animate !== 'function') return;
    var running = null;
    var ease = 'cubic-bezier(0.22, 1, 0.36, 1)';
    function finish() {
      body.style.overflow = '';
      running = null;
    }
    summary.addEventListener('click', function (event) {
      event.preventDefault();
      if (running) {
        if (details.classList.contains('is-closing')) {
          details.classList.remove('is-closing');
          running.onfinish = running.oncancel = finish;
        } else {
          details.classList.add('is-closing');
          running.onfinish = running.oncancel = function () { details.open = false; details.classList.remove('is-closing'); finish(); };
        }
        running.reverse();
        return;
      }
      var pad = window.getComputedStyle(body).paddingBottom;
      body.style.overflow = 'hidden';
      if (details.open) {
        details.classList.add('is-closing');
        running = body.animate(
          [{ height: body.offsetHeight + 'px', paddingBottom: pad, opacity: 1 }, { height: '0px', paddingBottom: '0px', opacity: 0 }],
          { duration: 300, easing: ease }
        );
        running.onfinish = running.oncancel = function () { details.open = false; details.classList.remove('is-closing'); finish(); };
      } else {
        details.open = true;
        running = body.animate(
          [{ height: '0px', paddingBottom: '0px', opacity: 0, transform: 'translateY(-6px)' }, { height: body.offsetHeight + 'px', paddingBottom: pad, opacity: 1, transform: 'none' }],
          { duration: 420, easing: ease }
        );
        running.onfinish = running.oncancel = finish;
      }
    });
  }

  var revealObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          entry.target.querySelectorAll('[data-nv-type]').forEach(typeText);
          revealObserver.unobserve(entry.target);
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' })
    : null;

  var videoObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            playInView(video);
          } else if (!video.hasAttribute('data-nv-once')) {
            video.pause();
          }
        });
      }, { threshold: 0.35 })
    : null;

  var parallaxItems = [];
  var progressItems = [];
  var spanItems = [];
  var ticking = false;

  function update() {
    ticking = false;
    var vh = window.innerHeight;
    // Erst alles messen, dann alles setzen – sonst muss der Browser beim Scrollen das Layout mehrfach neu berechnen
    var writes = [];
    // Der Parallax-Effekt läuft nur am Desktop: Auf Touch-Geräten hinkt er dem Finger hinterher und wirkt unruhig
    if (!touchQuery.matches) {
      parallaxItems.forEach(function (el) {
        var rect = el.parentElement.getBoundingClientRect();
        if (rect.bottom < -200 || rect.top > vh + 200) return;
        var speed = parseFloat(el.dataset.nvParallax) || 0.08;
        var offset = (rect.top + rect.height / 2 - vh / 2) * -speed;
        writes.push([el, '--nv-py', offset.toFixed(1) + 'px']);
      });
    }
    spanItems.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      if (rect.bottom < -vh || rect.top > vh * 2) return;
      var p = (vh * 0.72 - rect.top) / Math.max(1, rect.height);
      writes.push([el, '--nv-p', Math.min(1, Math.max(0, p)).toFixed(3)]);
    });
    progressItems.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      if (rect.bottom < -vh || rect.top > vh * 2) return;
      var p = (vh - rect.top) / (vh * 0.9);
      writes.push([el, '--nv-p', Math.min(1, Math.max(0, p)).toFixed(3)]);
    });
    for (var i = 0; i < writes.length; i++) writes[i][0].style.setProperty(writes[i][1], writes[i][2]);
  }

  function requestUpdate() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(update);
    }
  }

  function init(root) {
    root = root || document;

    root.querySelectorAll('[data-nv-split]').forEach(splitWords);
    root.querySelectorAll('details.nv-acc').forEach(initAccordion);

    root.querySelectorAll('[data-nv-stagger]').forEach(function (group) {
      group.querySelectorAll('[data-nv-reveal]').forEach(function (el, i) {
        el.style.setProperty('--nv-i', i % 8);
      });
    });

    root.querySelectorAll('[data-nv-reveal], [data-nv-split], .nv-mask').forEach(function (el) {
      if (reduceMotion || !revealObserver) {
        el.classList.add('is-in');
        el.querySelectorAll('[data-nv-type]').forEach(typeText);
      } else {
        revealObserver.observe(el);
      }
    });

    root.querySelectorAll('video[data-nv-video]').forEach(function (video) {
      initVideo(video);
      if (!video.hasAttribute('data-nv-autoplay') && videoObserver) videoObserver.observe(video);
    });

    if (!reduceMotion) {
      root.querySelectorAll('[data-nv-parallax]').forEach(function (el) {
        if (parallaxItems.indexOf(el) === -1) parallaxItems.push(el);
      });
    }
    root.querySelectorAll('[data-nv-progress-span]').forEach(function (el) {
      if (reduceMotion) { el.style.setProperty('--nv-p', 1); } else if (spanItems.indexOf(el) === -1) { spanItems.push(el); }
    });

    // Kennzahlen hochzählen, sobald sie sichtbar werden
    root.querySelectorAll('[data-nv-count]').forEach(function (el) {
      if (el.dataset.nvCountDone) return;
      var raw = String(el.dataset.nvCount).replace(/,/g, '');
      var target = parseFloat(raw);
      if (isNaN(target) || reduceMotion || !('IntersectionObserver' in window)) { el.dataset.nvCountDone = '1'; return; }
      var decimals = (raw.split('.')[1] || '').length;
      var format = function (n) { var parts = n.toFixed(decimals).split('.'); parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','); return parts.join('.'); };
      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        el.dataset.nvCountDone = '1';
        var start = null;
        var step = function (t) {
          if (!start) start = t;
          var k = Math.min(1, (t - start) / 1400);
          var eased = 1 - Math.pow(1 - k, 3);
          el.textContent = format(target * eased);
          if (k < 1) window.requestAnimationFrame(step); else el.textContent = el.dataset.nvCount;
        };
        window.requestAnimationFrame(step);
      }, { threshold: 0.6 });
      io.observe(el);
    });

    root.querySelectorAll('[data-nv-progress]').forEach(function (el) {
      if (reduceMotion) {
        el.style.setProperty('--nv-p', 1);
      } else if (progressItems.indexOf(el) === -1) {
        progressItems.push(el);
      }
    });

    requestUpdate();
  }

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);
  mobileQuery.addEventListener('change', function () {
    document.querySelectorAll('video[data-nv-video][data-nv-autoplay]').forEach(function (video) {
      pickVideoSource(video);
      video.play().catch(function () {});
    });
  });

  // Browser pausieren Videos in Hintergrund-Tabs — beim Zurückkehren weiterspielen
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState !== 'visible' || reduceMotion) return;
    document.querySelectorAll('video[data-nv-video][data-nv-autoplay]').forEach(function (video) {
      video.play().catch(function () {});
    });
  });

  // Theme-Editor: Sektionen neu initialisieren, wenn sie geladen oder verändert werden
  document.addEventListener('shopify:section:load', function (event) {
    parallaxItems = parallaxItems.filter(function (el) { return document.body.contains(el); });
    progressItems = progressItems.filter(function (el) { return document.body.contains(el); });
    spanItems = spanItems.filter(function (el) { return document.body.contains(el); });
    init(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
})();
